import {
  Box,
  HStack,
  KdsDivider,
  KdsLink,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { SandboxItemReadDtoDispatchTypeEnum } from "@/config/apiClient";
import { type VersionsBlocProps } from "./VersionsBloc.types";

export const VersionsBloc = ({
  sandboxItem,
  onTabNavigation,
}: VersionsBlocProps) => {
  const { t } = useTranslate();

  const sandboxItemVersions = sandboxItem.SandboxItemVersion;

  return (
    <Box rounded="br-lg" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <HStack gap="sp-sm" wrap="wrap" align="center">
          <KdsText as="h2" size="title-sm" transform="capitalize">
            {t("version.title", { count: sandboxItemVersions.length })}
          </KdsText>
        </HStack>

        {sandboxItem.SandboxItemVersion.map((version, index) => (
          <VStack key={`${version.id}-${version.name}`} gap="sp-sm" wrap="wrap">
            <KdsText dataCy={`versionName${index}`}>
              {t("order.myOrdersItemDetails.versionName", {
                name: version.name,
              })}
            </KdsText>

            <HStack gap="sp-xs2">
              {sandboxItem.dispatchType !==
              SandboxItemReadDtoDispatchTypeEnum.DispatchFiles ? (
                <KdsText dataCy={`versionQuantity${index}`}>
                  {t("order.myOrdersItemDetails.versionQuantity", {
                    quantity: version.SandboxItemVersionDispatch.reduce(
                      (sum, dispatch) => sum + dispatch.quantity,
                      0
                    ),
                  })}
                </KdsText>
              ) : (
                <>
                  <KdsText dataCy={`versionQuantity${index}`}>
                    {t("orderItemSummary.details.quantity")}
                  </KdsText>

                  <KdsLink
                    size="sm"
                    onPress={() => onTabNavigation?.("documents")}
                  >
                    {t("orderItemSummary.details.dispatchLink")}
                  </KdsLink>
                </>
              )}
            </HStack>

            {index < sandboxItem.SandboxItemVersion.length - 1 && (
              <KdsDivider />
            )}
          </VStack>
        ))}

        <KdsLink size="sm" onPress={() => onTabNavigation?.("design_proofs")}>
          {t("orderItemSummary.details.hdLink")}
        </KdsLink>
      </VStack>
    </Box>
  );
};
